import { REGIONS } from '@/assets/region-mapping'
import type { RegionSlug } from '@/types/map'

export interface RegionPickerProps {
  onSelect: (slug: RegionSlug) => void
  onReset: () => void
}

export function RegionPicker({ onSelect, onReset }: RegionPickerProps) {
  return (
    <ul
      role="menu"
      className="absolute z-20 mt-1 w-52 rounded-md border border-[color:var(--border-default)] bg-[color:var(--surface-elevated)] py-1 shadow-lg"
    >
      <li
        data-testid="region-option"
        role="menuitem"
        onClick={onReset}
        className="cursor-pointer px-3 py-1 text-sm hover:bg-[color:var(--surface-secondary)]"
      >
        Globe (reset)
      </li>
      {(Object.keys(REGIONS) as RegionSlug[]).map((slug) => (
        <li
          key={slug}
          data-testid="region-option"
          role="menuitem"
          onClick={() => onSelect(slug)}
          className="cursor-pointer px-3 py-1 text-sm hover:bg-[color:var(--surface-secondary)]"
        >
          {REGIONS[slug].label}
        </li>
      ))}
    </ul>
  )
}
